import { useContext } from 'react';

import { AttendeeState } from 'app/shared/typings';
import { AuthContext } from 'app/shared/context/Auth';
import { GetUserUpcomingEventAttendees } from 'app/fan/graphql/users/queryHooks';

interface UserAttendeeStates {
  [eventID: string]: AttendeeState;
}

export const useUserAttendeeStates = () => {
  const { user } = useContext(AuthContext);

  const {
    data: upcomingEventAttendeesData,
    error: upcomingEventAttendeesError,
    loading: upcomingEventAttendeesLoading,
  } = GetUserUpcomingEventAttendees({
    skip: !user,
  });

  if (
    !user ||
    upcomingEventAttendeesError ||
    upcomingEventAttendeesLoading ||
    !upcomingEventAttendeesData
  ) {
    return {};
  }

  const upcomingEventAttendees =
    upcomingEventAttendeesData?.user?.upcomingEventAttendees;

  if (!upcomingEventAttendees || upcomingEventAttendees.length === 0) {
    return {};
  }

  const userAttendeeStatesByEventId: UserAttendeeStates =
    upcomingEventAttendees.reduce((acc, val) => {
      if (val.eventId && val.visibleToUser) {
        acc[val.eventId] = val.currentState;
      }
      return acc;
    }, {} as UserAttendeeStates);

  return userAttendeeStatesByEventId;
};
